/* eslint-disable react/prop-types */
import {
	Alert,
	Box,
	Button,
	Grid,
	Input,
	InputLabel,
	MenuItem,
	Select,
	Snackbar,
	Typography,
	TextField,
	Modal,
	IconButton,
	InputAdornment,
} from '@mui/material';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import manageProfileIcon from '../../../../../assets/logos/manageProfileicon.png';

import profilePicture from '../../../../../assets/logos/profilePicture.png';

import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import { styled } from '@mui/system';
import { addStaff } from '../../../../services/api/apiManager';
import CancelIcon from '@mui/icons-material/Cancel';

import * as Yup from 'yup';
import dayjs from 'dayjs';
import { Call } from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const StyledFileInput = styled('input')({
	display: 'none', // Hide the input visually
});

const StyledTypography = styled(Typography)({
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: '300',
	color: '#726A6A',
	textDecoration: 'underline',
	cursor: 'pointer',
});
const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '55%',
	backgroundColor: 'white',
	border: ' 1px solid #00000026',
	borderRadius: '12px',
};
function AddStaff(props) {
	const defaultTheme = createTheme();

	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [openModal, setOpenModal] = useState(true);
	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);

		// this prop sending data to my parent component so whenever i close my modal ViewPayer Component will be shown
		props.renderHandleFromChild('viewStaff');
	};
	const schema = Yup.object().shape({
		Fname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Lname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		Title: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Type should contain only alphabets'),

		City: Yup.string().matches(
			/^[a-zA-Z\s]+$/,
			'City Name should contain only alphabets'
		),
		State: Yup.string().matches(
			/^[a-zA-Z]+$/,
			'State Name should contain only alphabets without empty spaces'
		),
		Specialty: Yup.string().matches(/^[a-zA-Z\s]+$/, ' only alphabets'),
		Contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		NPI: Yup.string().matches(/^\d+$/, 'Numbers only '),
		Zip: Yup.string().matches(/^\d+$/, 'Numbers only '),
	});

	const [errors, setErrors] = useState({});
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setStaff((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const practice_id = localStorage.getItem('practice_id');
	const [staff, setStaff] = useState({
		practice_id: practice_id,
		Fname: '',
		Lname: '',
		DOB: '',
		Gender: '',
		Contact: '',
		Title: '',
		NPI: '',
		Email: '',
		Address: '',
		Specialty: '',
		City: '',
		State: '',
		Zip: '',
		Comments: '',
	});
	const addStaffData = async () => {
		try {
			if (
				!staff.Title ||
				!staff.Fname ||
				!staff.Lname ||
				!staff.Specialty ||
				!staff.NPI ||
				!staff.Gender ||
				!staff.Contact ||
				!staff.DOB ||
				!staff.Address ||
				!staff.City ||
				!staff.State ||
				!staff.Zip
			) {
				setEmptyFieldError(true);
				return;
			}
			await schema.validate(staff, { abortEarly: false });
			const response = await addStaff(staff);
			if (response?.status === 201) {
				handleCloseModal();
				// this props is sending data to parent for opening modal
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'green',
					snakbarFor: 'staff',
				});
				setStaff(true);
				setOpenSnackbar(true);
			} else if (response?.status === 400) {
				setOpenSnackbarError(true);
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'staff',
				});
			} else {
				setOpenSnackbarError(true);
				props.openSanckbarFromChild({
					openBar: true,
					barColor: 'red',
					snakbarFor: 'staff',
				});
			}
		} catch (error) {
			console.error('Error updating staff:', error);
		}
	};
	const [addPicture, setAddPicture] = useState(null);

	const handleFileInputChange = (event) => {
		const file = event.target.files[0];
		const reader = new FileReader();
		reader.onload = () => {
			setAddPicture(reader.result);
		};
		reader.readAsDataURL(file);
	};

	return (
		<ThemeProvider theme={defaultTheme}>
			{/* Darks code Start from here  */}
			<Modal
				open={openModal}
				// onClose={handleCloseModal}
				aria-labelledby="edit-modal-title"
				aria-describedby="edit-modal-description"
				sx={{
					'& .MuiModal-backdrop': {
						opacity: '3 !important',
					},
				}}
			>
				<Box sx={style}>
					<Grid container lg={12} xs={12} md={12} sm={12}>
						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							justifyContent="center"
						>
							<Box
								sx={{
									width: '100%',
									height: '65px',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									borderBottom: '1px solid #00000070',
								}}
							>
								<Typography
									sx={{
										width: '88%',
										fontFamily: 'Poppins',
										fontSize: '32px',
										fontWeight: 500,
										textAlign: 'center',
									}}
								>
									Add Staff
								</Typography>
								<IconButton onClick={handleCloseModal}>
									<CancelIcon sx={{ fontSize: '30px' }} color="error" />
								</IconButton>
							</Box>
						</Grid>
					</Grid>
					<Grid container lg={12} xs={12} md={12} sm={12} p={3}>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Title<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Title == ''}
								name="Title"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Title}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Title && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Title}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								First Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Fname == ''}
								name="Fname"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Fname}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Fname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Fname}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Last Name<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Lname == ''}
								name="Lname"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Lname}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Lname && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Lname}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								DOB<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								name="DOB"
								size="small"
								fullWidth
								disableUnderline
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, DOB: e.target.value }))
								}
								error={staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')}
								helperText={
									staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')
										? '*Please Add Accurate DOB'
										: ''
								}
								type="date"
								format="YYYY-MM-DD"
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
									border: `${emptyField && staff?.DOB == '' && '1px solid #d61b1b'}`,
								}}
							/>
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Specialty<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Specialty == ''}
								name="Specialty"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Specialty}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Specialty && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Specialty}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={4} xs={4} md={4} sm={4} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Gender<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<Select
								error={emptyField && staff?.Gender == ''}
								name="Gender"
								size="small"
								fullWidth
								displayEmpty
								inputProps={{ padding: '2px' }}
								value={staff?.Gender}
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, Gender: e.target.value }))
								}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							>
								<MenuItem value="">Select</MenuItem>
								<MenuItem value={'M'}>Male</MenuItem>
								<MenuItem value={'F'}>Female</MenuItem>
							</Select>
						</Grid>
						<Grid item lg={6} xs={6} md={6} sm={6} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								NPI<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.NPI == ''}
								name="NPI"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.NPI}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.NPI && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.NPI}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid item lg={6} xs={6} md={6} sm={6} sx={{ padding: '10px 5px' }}>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Mobile<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<MaskedInput
								required
								value={staff?.Contact}
								onChange={handleInputChange}
								name="Contact"
								mask={[
									'(',
									/\d/,
									/\d/,
									/\d/,
									')',
									' ',
									/\d/,
									/\d/,
									/\d/,
									'-',
									/\d/,
									/\d/,
									/\d/,
									/\d/,
								]}
								style={{
									width: '100%',
									borderRadius: '6px',
									height: '40px',
									marginBottom: '8px',
									// marginTop: '8px',
									border: `${emptyField && staff?.Contact == '' ? '1px solid #d61b1b' : '1.5px solid #DDE6F1'}`,
									padding: '5px 0px 5px 6px',

									outlineColor: '#f3a765',
									boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25) inset',
								}}
							/>
							{errors.Contact && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Contact}
								</div>
							)}{' '}
						</Grid>

						<Grid
							item
							lg={12}
							xs={12}
							md={12}
							sm={12}
							xl={12}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								Address<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Address == ''}
								name="Address"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Address}
								onChange={(e) =>
									setStaff((prev) => ({ ...prev, Address: e.target.value }))
								}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								City<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.City == ''}
								name="City"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.City}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.City && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.City}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								State<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.State == ''}
								name="State"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.State}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.State && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.State}
								</div>
							)}{' '}
							{/* Display validation error */}
						</Grid>
						<Grid
							item
							lg={4}
							xs={4}
							md={4}
							sm={4}
							xl={4}
							sx={{ padding: '10px 5px' }}
						>
							<InputLabel
								sx={{
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: '500',
									textAlign: 'left',
									color: 'black',
								}}
							>
								ZIP<span style={{ color: '#d61b1b' }}>*</span>
							</InputLabel>
							<TextField
								error={emptyField && staff?.Zip == ''}
								name="Zip"
								type="text"
								size="small"
								fullWidth
								disableUnderline
								value={staff?.Zip}
								onChange={handleInputChange}
								sx={{
									boxShadow: '0px 1px 10px 0px #79ACF178 inset',
									borderRadius: '4px',
								}}
							/>
							{errors.Zip && (
								<div style={{ color: 'red', fontSize: '10px' }}>
									{errors.Zip}
								</div>
							)}{' '}
						</Grid>
						<Box
							mt={1}
							width={'100%'}
							height={'70px'}
							display={'flex'}
							justifyContent={'center'}
							gap={2}
						>
							<Button
								onClick={handleCloseModal}
								style={{
									backgroundColor: '#ED2828',
									width: '151px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
							>
								Cancel
							</Button>
							<Button
								disabled={staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD')}
								style={{
									backgroundColor: `${staff.DOB >= dayjs(new Date()).format('YYYY-MM-DD') ? 'grey' : '#00A2E8'}`,
									width: '151px',
									height: '52px',
									borderRadius: '7px',
									color: '#FFFFFF',
									fontSize: '20px',
								}}
								onClick={() => {
									addStaffData();
								}}
							>
								Add
							</Button>
						</Box>
					</Grid>
				</Box>
			</Modal>
			{/* Darks code ends here */}

			{/* snack bar for Patient added successfully */}
			<Snackbar
				open={openSnackbar}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					New Staff Added Successfully
				</Alert>
			</Snackbar>
			{/* snack bar for 401 error  */}
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>

			{/* snack bar for empty field  */}

			<Snackbar
				open={emptyField}
				autoHideDuration={2000} // Adjust the duration as needed
				onClose={handleEmptyFieldError}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleEmptyFieldError}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '14px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white', // Change icon color to white
						},
					}}
				>
					Fill all the Fields
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default AddStaff;
